import { ThemeContext } from './ThemeContext';
import { ThemeProviderProps } from './ThemeProvider.types';
import { useStyles } from './ThemeProvider.styles';
import { defaultTheme } from '../../themes';

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const styles = useStyles(defaultTheme);
  return (
    <ThemeContext.Provider value={defaultTheme}>
      <div css={[styles.sidebar]}>{children}</div>
    </ThemeContext.Provider>
  );
};
